import { useState, useEffect, useCallback, useMemo } from "react";
import axios from "axios";
import { IconButton, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Lightpole from "/Lightpole.png?url";
import Lightoff from "/LightOff.png?url";

const ArcGauge = ({ poleId, onValueChange }) => {
  const [value, setValue] = useState(0);

  const fetchData = useCallback(async () => {
    if (!poleId) {
      setValue(0);
      return;
    }

    try {
      const response = await axios.get(
        `${import.meta.env.VITE_API_URL}/latest-audit/${poleId}`
      );
      const fetchedValue = response.data?.payload?.value ?? 0;
      setValue(fetchedValue);
    } catch (error) {
      console.error("Error fetching data:", error);
      setValue(0);
    }
  }, [poleId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleValueChange = useCallback((newValue) => {
    const clampedValue = Math.min(Math.max(newValue, 0), 100);
    setValue(clampedValue);
    console.log("New value:", clampedValue);
    onValueChange(clampedValue);
  }, [onValueChange]);

  const incrementValue = () => handleValueChange(value + 10);
  const decrementValue = () => handleValueChange(value - 10);

  const rotation = useMemo(() => (180 * value) / 100, [value]);
  const imageToShow = value === 0 ? Lightoff : Lightpole;

  return (
    <div>
      <ArcDisplay rotation={rotation} value={value} imageToShow={imageToShow} />
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 2 }}>
        <IconButton onClick={decrementValue} disabled={value === 0}>
          <RemoveIcon />
        </IconButton>
        <input
          type="range"
          min="0"
          max="100"
          value={value}
          onChange={(e) => handleValueChange(parseInt(e.target.value))}
          className="gradient-range"
          style={{ margin: '0 10px' }}
        />
        <IconButton onClick={incrementValue} disabled={value === 100}>
          <AddIcon />
        </IconButton>
      </Box>
    </div>
  );
};

const ArcDisplay = ({ rotation, value, imageToShow }) => (
  <div className="chart-skills" style={chartStyles}>
    <div className="p90"></div>
    <div className="p75"></div>
    <div className="p25"></div>
    <div style={{ ...arcStyles, transform: `translateX(-50%) rotate(${rotation}deg)` }}></div>
    <span style={valueStyles}>
      <img src={imageToShow} style={imageStyles} alt="Light status" />
      {value}%
    </span>
  </div>
);

const chartStyles = {
  position: "relative",
  width: "350px",
  height: "175px",
  margin: "0 auto",
};

const arcStyles = {
  position: "absolute",
  top: "0",
  left: "50%",
  width: "350px",
  height: "175px",
  transformOrigin: "50% 100%",
  border: "44px solid #F2F4F7",
  borderBottom: "none",
  borderTopLeftRadius: "175px",
  borderTopRightRadius: "175px",
  transition: "transform 0.2s linear",
};

const valueStyles = {
  position: "absolute",
  left: "50%",
  bottom: "0px",
  transform: "translateX(-50%)",
  fontSize: "32px",
  fontWeight: "bold",
  color: "#fff",
  display: "grid",
};

const imageStyles = {
  position: "absolute",
  left: "50%",
  bottom: "60px",
  transform: "translateX(-50%)",
};

export default ArcGauge;